function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { memo, useCallback, useEffect, useMemo, useRef } from 'react';
import { classnames, isKorean } from '@bydesign-ui/utils';
import { useRefCallback, useToggle, useUpdate } from '@bydesign-ui/hooks';
import { useDirection, useLocale, usePrefixCls } from '@byte-design/config';
import { HotKeyContext, useCreateHotKey } from '../../hooks/hotkey';
import { Tag } from '../tag';
import { CloseOne } from './../../common/icons';
import { SelectHotKey } from './SelectHotKey';
var SelectInputWrapperComponent = memo(function (options) {
  var select = useLocale('select.placeholder');

  var inputRef = options.inputRef,
      _options$autoFocusAft = options.autoFocusAfterShow,
      autoFocusAfterShow = _options$autoFocusAft === void 0 ? true : _options$autoFocusAft,
      type = options.type,
      className = options.className,
      icon = options.icon,
      _options$popperInput = options.popperInput,
      popperInput = _options$popperInput === void 0 ? false : _options$popperInput,
      inputSize = options.inputSize,
      _options$keyword = options.keyword,
      keyword = _options$keyword === void 0 ? '' : _options$keyword,
      _options$placeholder = options.placeholder,
      placeholder = _options$placeholder === void 0 ? select : _options$placeholder,
      _options$datasource = options.datasource,
      datasource = _options$datasource === void 0 ? [] : _options$datasource,
      _options$show = options.show,
      show = _options$show === void 0 ? false : _options$show,
      _options$multiple = options.multiple,
      multiple = _options$multiple === void 0 ? false : _options$multiple,
      _options$disabled = options.disabled,
      disabled = _options$disabled === void 0 ? false : _options$disabled,
      _options$readonly = options.readonly,
      readonly = _options$readonly === void 0 ? false : _options$readonly,
      _options$writeable = options.writeable,
      writeable = _options$writeable === void 0 ? false : _options$writeable,
      _options$invalid = options.invalid,
      invalid = _options$invalid === void 0 ? false : _options$invalid,
      onCloseItem = options.onCloseItem,
      onChange = options.onChange,
      forwardedRef = options.forwardedRef,
      _options$size = options.size,
      size = _options$size === void 0 ? 'md' : _options$size,
      width = options.width,
      renderContent = options.renderContent,
      _options$clearable = options.clearable,
      clearable = _options$clearable === void 0 ? false : _options$clearable,
      _options$selectedItem = options.selectedItemRemovable,
      selectedItemRemovable = _options$selectedItem === void 0 ? true : _options$selectedItem,
      onHide = options.onHide,
      onClear = options.onClear,
      multipleRenderSelected = options.multipleRenderSelected,
      renderSelectedName = options.renderSelectedName,
      onValueChange = options.onValueChange,
      hotKeyHandlers = options.hotKeyHandlers,
      prepend = options.prepend,
      append = options.append,
      prefix = options.prefix,
      onBlur = options.onBlur,
      onPressEnter = options.onPressEnter,
      filled = options.filled,
      extra = _objectWithoutProperties(options, ["inputRef", "autoFocusAfterShow", "type", "className", "icon", "popperInput", "inputSize", "keyword", "placeholder", "datasource", "show", "multiple", "disabled", "readonly", "writeable", "invalid", "onCloseItem", "onChange", "forwardedRef", "size", "width", "renderContent", "clearable", "selectedItemRemovable", "onHide", "onClear", "multipleRenderSelected", "renderSelectedName", "onValueChange", "hotKeyHandlers", "prepend", "append", "prefix", "onBlur", "onPressEnter", "filled"]);

  var direction = useDirection();
  var update = useUpdate();
  var selectInputRef = useRef(null);
  var contentWrapperRef = useRef(null);
  var innerInputRef = useMemo(function () {
    return inputRef ? inputRef : selectInputRef;
  }, [inputRef]);
  var fakeInputRef = useRef(null);
  var focusableElementRef = writeable ? innerInputRef : fakeInputRef;
  var hotKey = useCreateHotKey(focusableElementRef);
  var onHideCallback = useRefCallback(onHide);
  var onChangeCallback = useRefCallback(onChange);
  var onValueChangeCallback = useRefCallback(onValueChange);
  var onBlurCallBack = useRefCallback(onBlur);
  var onPressEnterCallBack = useRefCallback(onPressEnter);
  var isOnComposition = useRef(false);
  var userValue = useRef(keyword);

  if (!isOnComposition.current && keyword !== userValue.current) {
    userValue.current = keyword;
  }

  var onCloseItemCallback = useRefCallback(onCloseItem);
  var handleCloseItem = useCallback(function (data) {
    !disabled && !readonly && onCloseItemCallback(data);
  }, [disabled, readonly]);
  var onClearCallback = useRefCallback(onClear);
  var handleReset = useCallback(function (e) {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    onClearCallback();
  }, []);

  var _useToggle = useToggle(false),
      _useToggle2 = _slicedToArray(_useToggle, 3),
      focused = _useToggle2[0],
      setFocused = _useToggle2[1],
      setBlurred = _useToggle2[2];

  var handleBlur = useCallback(function (e) {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    onBlurCallBack && onBlurCallBack(e);
    setBlurred();
  }, []);

  var setFocus = function setFocus() {
    var _a;

    if (!disabled && !readonly && autoFocusAfterShow) {
      (_a = focusableElementRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }
  };

  var setBlur = function setBlur() {
    var _a;

    if (autoFocusAfterShow) {
      (_a = focusableElementRef.current) === null || _a === void 0 ? void 0 : _a.blur();
      setBlurred();
    }
  };

  useEffect(function () {
    var _a;

    if (!popperInput) {
      (_a = contentWrapperRef.current) === null || _a === void 0 ? void 0 : _a.scrollTo({
        left: 0,
        top: 0,
        behavior: 'smooth'
      });
    }
  }, [popperInput]);
  var handleWrapperClick = useCallback(function () {
    if (popperInput) {
      onHideCallback();
    }

    setFocus();
  }, [popperInput]);
  var handleChange = useCallback(function (e) {
    userValue.current = e.target.value;

    if (isOnComposition.current) {
      update();
      return;
    }

    onChangeCallback(e);
    onValueChangeCallback(e.target.value);
  }, []);
  var handleComposition = useCallback(function (e) {
    var text = e.currentTarget.value;
    userValue.current = text;

    if (e.type === 'compositionend') {
      isOnComposition.current = false;
      onChangeCallback(e);
      onValueChangeCallback(text);
    } else {
      var lastCharacter = text[text.length - 1] || '';
      isOnComposition.current = !isKorean(lastCharacter);
    }
  }, []);
  var handleKeyDown = useCallback(function (e) {
    e.keyCode === 13 && onPressEnterCallBack && onPressEnterCallBack(e);
  }, []);
  var wrapperCls = classnames(usePrefixCls('select-input-wrapper', {
    'popover-input': popperInput,
    render: Boolean(multipleRenderSelected),
    size: size,
    disabled: disabled,
    readonly: readonly,
    prepend: !!prepend,
    append: !!append,
    focused: focused,
    rtl: direction === 'rtl'
  }), className);
  var prefixCls = usePrefixCls('select-input-wrapper-prefix');
  var contentWrapper = usePrefixCls('select-input-content-wrapper');
  var innerCls = usePrefixCls('select-input-inner', {
    simple: !multiple,
    single: !popperInput && datasource.length <= 1
  });
  var inputCls = usePrefixCls('select-input', {
    warning: invalid,
    filled: filled
  });
  var iconCls = usePrefixCls('select-input-icon');
  var selectTipCls = usePrefixCls('select-tip');
  var selectValueCls = usePrefixCls('select-value');
  useEffect(function () {
    if (writeable) {
      if (show) {
        setFocus();
      } else {
        setBlur();
      }
    }
  }, [writeable, show]);

  var renderNormal = function renderNormal() {
    if (!multiple || !datasource.length) {
      return React.createElement("input", {
        ref: innerInputRef,
        type: type,
        className: selectValueCls,
        readOnly: true,
        disabled: disabled,
        placeholder: placeholder,
        onFocus: setFocused,
        onBlur: handleBlur,
        onKeyDown: handleKeyDown,
        value: datasource[0] ? renderSelectedName ? renderSelectedName(datasource[0]) : datasource[0].label || '' : keyword
      });
    }

    return datasource.map(function (item) {
      return React.createElement(Tag, {
        fill: !filled,
        key: item.value,
        size: size,
        closeable: !(disabled || readonly) && selectedItemRemovable,
        onClose: function onClose() {
          return handleCloseItem(item);
        }
      }, renderSelectedName ? renderSelectedName(item) : item.label);
    });
  };

  var renderWriteable = function renderWriteable() {
    var inpWidth = 20 + 16 * (userValue.current && userValue.current.toString().length || 0);

    if (!multiple) {
      return React.createElement("input", {
        ref: innerInputRef,
        type: type,
        value: userValue.current,
        onChange: handleChange,
        placeholder: placeholder,
        className: selectValueCls,
        readOnly: disabled || readonly || !onChange,
        onCompositionStart: handleComposition,
        onCompositionUpdate: handleComposition,
        onCompositionEnd: handleComposition,
        onFocus: setFocused,
        onBlur: handleBlur,
        onKeyDown: handleKeyDown
      });
    }

    return React.createElement(React.Fragment, null, datasource.map(function (item) {
      return React.createElement(Tag, {
        fill: !filled,
        key: item.value,
        size: size,
        closeable: !(disabled || readonly) && selectedItemRemovable,
        onClose: function onClose() {
          return handleCloseItem(item);
        }
      }, renderSelectedName ? renderSelectedName(item) : item.label);
    }), React.createElement("input", {
      ref: innerInputRef,
      type: type,
      key: "multi-input-value",
      value: keyword,
      onChange: onChange,
      placeholder: datasource.length ? undefined : placeholder,
      className: selectValueCls,
      readOnly: disabled || readonly || !onChange,
      style: {
        width: "".concat(inpWidth, "px"),
        maxWidth: '100%',
        verticalAlign: 'top'
      },
      onFocus: setFocused,
      onBlur: handleBlur,
      onKeyDown: handleKeyDown
    }));
  };

  var _useToggle3 = useToggle(false),
      _useToggle4 = _slicedToArray(_useToggle3, 3),
      hover = _useToggle4[0],
      setEnter = _useToggle4[1],
      setLeave = _useToggle4[2];

  var renderIcon = function renderIcon() {
    if (!disabled && !readonly && clearable && hover && (renderContent || datasource.length || writeable)) {
      return React.createElement(CloseOne, {
        theme: "filled",
        onClick: handleReset
      });
    }

    return icon;
  };

  return React.createElement("div", Object.assign({}, extra, {
    ref: forwardedRef,
    className: wrapperCls,
    style: {
      width: width != null ? width : inputSize ? "".concat(inputSize.width, "px") : undefined
    },
    onClick: handleWrapperClick,
    onMouseEnter: setEnter,
    onMouseLeave: setLeave
  }), React.createElement(HotKeyContext.Provider, {
    value: hotKey
  }, React.createElement(SelectHotKey, {
    focusableElementRef: focusableElementRef,
    handlers: hotKeyHandlers
  })), React.createElement("div", {
    className: inputCls,
    ref: fakeInputRef,
    tabIndex: 0,
    onBlur: function onBlur(e) {
      e.stopPropagation();
    }
  }, !multipleRenderSelected && !popperInput && datasource.length > 1 && React.createElement("span", {
    className: selectTipCls
  }, datasource.length)), React.createElement("div", {
    className: contentWrapper,
    ref: contentWrapperRef
  }, React.createElement("div", {
    className: innerCls
  }, !!prefix && React.createElement("span", {
    className: prefixCls
  }, prefix), multipleRenderSelected ? multipleRenderSelected(datasource) : renderContent ? renderContent(popperInput) : writeable ? renderWriteable() : renderNormal())), React.createElement("span", {
    className: iconCls
  }, renderIcon()));
});
export var SelectInputWrapper = React.forwardRef(function (props, ref) {
  var append = props.append,
      className = props.className,
      invalid = props.invalid,
      prepend = props.prepend;
  var prependClassName = usePrefixCls('select-input-prepend', {
    warning: invalid
  });
  var appendClassName = usePrefixCls('select-input-append', {
    warning: invalid
  });
  var wrapperBoxCls = classnames(usePrefixCls('select-input-wrapper-box'), className);

  if (prepend || append) {
    return React.createElement("div", {
      className: wrapperBoxCls
    }, prepend && React.createElement("span", {
      className: prependClassName
    }, prepend), React.createElement(SelectInputWrapperComponent, Object.assign({}, props, {
      forwardedRef: ref
    })), append && React.createElement("span", {
      className: appendClassName
    }, append));
  }

  return React.createElement(SelectInputWrapperComponent, Object.assign({}, props, {
    forwardedRef: ref
  }));
});